/**
 * Utilitário para obter URL da API
 * Em produção no Cloudflare Pages, usa VITE_API_URL (Render)
 * Em desenvolvimento, usa /api (proxy do Vite)
 */
export const getApiUrl = (): string => {
  return import.meta.env.VITE_API_URL || '/api';
};

/**
 * Obter endpoint completo da API
 */
export const getApiEndpoint = (endpoint: string): string => {
  const apiUrl = getApiUrl();
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // Remover barra final da apiUrl se existir
  const cleanApiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
  
  // Se apiUrl já termina com /api, não duplicar
  if (cleanApiUrl.endsWith('/api')) {
    return `${cleanApiUrl}${normalizedEndpoint}`;
  }
  
  // Se apiUrl é relativo (/api), usar direto
  if (cleanApiUrl.startsWith('/')) {
    return `${cleanApiUrl}${normalizedEndpoint}`;
  }
  
  // Se apiUrl é absoluto (https://...), adicionar /api se necessário
  // Exemplo: https://site.vercel.app -> https://site.vercel.app/api/endpoint
  return `${cleanApiUrl}/api${normalizedEndpoint}`;
};

